module.exports = __webpack_public_path__ + "static/media/DPWorldLogo.2220bfbd.png";